module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Crash-4db96ae43531b9a64e3cbe6728b6ac3d.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Crash.mp3
// module id = 60
// module chunks = 0